const o = "1.11.0";
export {
  o as VERSION
};
